import DoctorGateway from '@/storage/gateways/DoctorGateway';
import AppointmentGateway from '@/storage/gateways/AppointmentGateway';

export default {
  install: (app, { axios }) => {
    const appointmentGateway = new AppointmentGateway(axios);
    const doctorGateway = new DoctorGateway(axios);
    Object.defineProperties(app.config.globalProperties, {
      $appointmentGateway: {
        get() { return appointmentGateway; },
      },
      $doctorGateway: {
        get() { return doctorGateway; },
      }
    });
  },
}